import { render } from "./Gegevns.vue?vue&type=template&id=abc7d524&scoped=true"
import script from "./Gegevns.vue?vue&type=script&lang=js"
export * from "./Gegevns.vue?vue&type=script&lang=js"

import "./Gegevns.vue?vue&type=style&index=0&id=abc7d524&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-abc7d524"

export default script